import React, {ChangeEvent, useCallback} from 'react';

import {sendDesktopAnalyticsEvent} from '@optimaxdev/analytics/desktop/lib/sendAnalyticsEvent/index';
import {Input} from '@optimaxdev/design-system';

import {useFeatureWithAnalytics} from 'components/feature';
import {CART_BUTTON} from 'constants/analytics/events/cart';

import {spawnPriorityTask} from 'libs/timers/spawnPriorityTask/spawnPriorityTask';

import {useCouponForm} from '../../hooks/useCouponForm/useCouponForm';

import s from './cartCoupon.scss';

/**
 * Coupon code form
 * @returns {React.ReactElement} - Counter component
 */
export const CartCoupon: React.FC = () => {
    const {errorMessage, onSubmit, ref, setValue, value} = useCouponForm();
    const isDCartUICouponBox = useFeatureWithAnalytics('dCartUI_CouponBox', false, 'desktop');
    const onFocus = useCallback(() => {
        spawnPriorityTask(() => {
            sendDesktopAnalyticsEvent(CART_BUTTON, {
                action: 'Coupon Box',
                label: 'Clicked',
            });
        });
    }, []);

    return (
        <div className={s.coupon} ref={ref}>
            <form onSubmit={onSubmit}>
                <div className={s.field}>
                    <div className={s.inputContainer}>
                        <Input
                            onChange={(event: ChangeEvent<HTMLInputElement>) =>
                                setValue(event.target.value)
                            }
                            aria-label="Add coupon"
                            color="dark"
                            label="Coupon / Store Credit"
                            name="couponField"
                            onFocus={onFocus}
                            style={{height: '48px'}}
                            type="text"
                            value={value}
                        />
                    </div>
                    <button className={s.apply} type="submit">
                        Apply
                    </button>
                </div>
            </form>

            {errorMessage ? (
                <span className={s.errorMessage}>{errorMessage}</span>
            ) : (
                !isDCartUICouponBox && (
                    <div className={s.note}>
                        <span>* Limited to 1 coupon code per purchase.</span>
                    </div>
                )
            )}
        </div>
    );
};
